import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getAccessToken } from 'utils/common'

type SetDispatchPasswordPayload = {
  dispatchUserId: string
  password: string
}

type SetPasswordResponse = {
  message: string
}

export const dispatchAuthApi = createApi({
  reducerPath: 'dispatchAuthApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_ONBOARDING_SERVICE_API}`,
    timeout: 2 * 60 * 1000,
    prepareHeaders: (headers) => {
      const token = getAccessToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  endpoints: (builder) => ({
    setDispatchUserPassword: builder.mutation<
      SetPasswordResponse,
      SetDispatchPasswordPayload
    >({
      query: ({ dispatchUserId, password }) => ({
        url: `oapi/v1/dispatch-auth/set-password?dispatchUserId=${dispatchUserId}`,
        method: 'POST',
        body: { password },
      }),
    }),
  }),
})

export const { useSetDispatchUserPasswordMutation } = dispatchAuthApi
